import { DynamicStandaloneProse, DynamicStandaloneProseProps } from '@/components/Prose';
import c from '@/styles/Richtextbox';
import { ClassNameProp, Component } from '@/types/component';
import deepmerge from 'deepmerge';
import { cn } from 'lib/utils/cn';
import { getPropStylesFactory } from 'lib/utils/getPropStylesFactory';

export interface RichtextboxProps extends DynamicStandaloneProseProps {
  variant?: ClassNameProp;
  colors?: ClassNameProp;
  size?: ClassNameProp;
}

// TODO: fix this after refactoring `Richtextbox`
// @ts-expect-error
const RichtextboxComponent: Component<RichtextboxProps> = ({ children, variant, colors, size, options, ...props }) => {
  const getPropStyles = getPropStylesFactory(c);
  const { className, ...baseOptions } = options ?? {};

  const sizeClassName = getPropStyles('size', size ?? variant);
  const colorsClassName = getPropStyles('colors', colors ?? variant);
  const variantClassName = getPropStyles('variant', variant);

  const componentClassName = cn(variantClassName, colorsClassName, sizeClassName, className);

  const overrideProse = (componentClassName as string)?.includes('prose');

  return (
    <DynamicStandaloneProse
      options={deepmerge(baseOptions, {
        size: overrideProse ? 'none' : undefined,
        className: componentClassName,
      })}
      {...props}
    />
  );
};

export const Richtextbox = RichtextboxComponent;
